export const types = {
  SET_RELEASE_TRACKS: "SET_RELEASE_TRACKS",
  UPSERT_RELEASE_TRACK: "UPSERT_RELEASE_TRACK",
};

export const setReleaseTracks = payload => ({
  type: types.SET_RELEASE_TRACKS,
  payload,
});

export const upsertReleaseTrack = payload => ({
  type: types.UPSERT_RELEASE_TRACK,
  payload,
});
